import { TransactionPeriod } from 'global/Securities/types/api/history';

export const PERIOD_SELECTIONS = [
  { value: TransactionPeriod.OneMonth, label: 'Last 1 Month' },
  { value: TransactionPeriod.ThreeMonths, label: 'Last 3 Months' },
  { value: TransactionPeriod.OneYear, label: 'Last 1 Year' },
];
